import * as MobX from "mobx";
import { ModelBase } from "@shoothill/core";

//Base class expects the model type and the DTO model type
//If you are not using a DTO just pass in undefined as the DTO
export class ApprovalSignalRModel extends ModelBase<ApprovalSignalRModel, ApprovalSignalRModelDTO> {
    constructor() {
        super();
    }

    @MobX.observable
    public required: number = 0;

    @MobX.observable
    public amendRequired: number = 0;

    @MobX.observable
    public totalCount: number = 0;

    //fromDto is required but you can leave it blank
    fromDto(model: ApprovalSignalRModelDTO): void {
        //this just iterates through every key assigning it to the model
        //Should only use if there is a direct mapping between dto and domain model
        //otherwise just map them yourself
        for (let key in model) {
            if (model.hasOwnProperty(key)) {
                if (this[key] instanceof Date) {
                    this[key] = new Date(model[key]);
                } else {
                    this[key] = model[key];
                }
            }
        }
    }

    //toDto is required but you can leave it blank
    toDto(model: ApprovalSignalRModel): void {}
}

export type ApprovalSignalRModelDTO = {
    amendRequired: number;
    required: number;
    totalCount: number;
};
